import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.salmon,
  textColor: colors.smoke,
  textColorDark: colors.smoke,
  textColorLight: colors.white
};
export default pencilBanner;